<script setup lang="ts">
import { computed } from 'vue';

import { brand } from '#/config/brand';
import { cn } from '#/lib/utils';

/**
 * 브랜드 로고 락업(대학 합격의 길 + 구분선 + 데오럭스 교육그룹).
 * - 헤더: 기본(컬러), 높이 26px.
 * - 푸터: variant="invert"(흰색 반전), 높이 32px.
 * shell.css .brand / .foot-brand .fb-logo 마크업을 Tailwind 유틸로 재현.
 */
interface Props {
  /** invert: 어두운 배경(푸터)용 흰색 반전 */
  variant?: 'default' | 'invert';
}
const props = withDefaults(defineProps<Props>(), {
  variant: 'default',
});

const isInvert = computed(() => props.variant === 'invert');

// mobile-first: 헤더 기본 21px → md(600)↑ 26px. 푸터는 32px 고정·흰색 반전.
const imgClass = computed(() =>
  cn('block w-auto flex-none', isInvert.value ? 'h-8 brightness-0 invert' : 'h-[21px] md:h-[26px]'),
);

const divClass = computed(() =>
  cn(
    'w-px flex-none',
    // 기본(헤더/로고): 네이비 18% 구분선 — bg-brand/[alpha] 는 토큰(var)이라 안 먹어 전용 토큰 사용.
    // invert(푸터): white 는 Tailwind 기본색이라 /[alpha] 정상.
    isInvert.value ? 'h-[26px] bg-white/[0.16]' : 'h-[19px] bg-[var(--brand-line)] md:h-6',
  ),
);
</script>

<template>
  <span class="flex items-center gap-3 md:gap-2.5">
    <img :class="imgClass" :src="brand.logos.daehak.src" :alt="brand.logos.daehak.alt" />
    <span :class="divClass" aria-hidden="true" />
    <img :class="imgClass" :src="brand.logos.deolux.src" :alt="brand.logos.deolux.alt" />
  </span>
</template>
